import React from "react";
import { FirstCard } from "./FirstCard";
import { SearchBar } from "./SearchBar";
import { StatusandFilters } from "./StatusandFilters";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import { MyDataGrid } from "./Table";
import { TabBar } from "./TabBar";
import Colors from "./../../../Global/colors";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
}));
export const Dashboard = ({
  value,
  handleSideBarChange,
  handleSideBarSubmit,
  templates,
  companies,
  inspections,
  sites,
  packageDetails,
  handleAuditClick,
  dataGlobal,
  handleLocationClick,
  handleNameClick,
  handleAuditorClick,
  barChartData,
  dateChart,
  filterByDateChart,
  setTableFilterOption,
  tableData,
  toggletable,
  tableFilterDate,
  tableFilterOption,
  handlePdfDownload,
  setDownloadIndex,
  downloadIndex,
  btnLoader,
  setBtnLoader,
  openModal,
  setModal
}) => {
  const classes = useStyles();
  return (
    <div className="" style={{display:'flex', flexDirection:'column',padding:'0px', overflow:'hidden',height:"calc(100vh - 50px)", backgroundColor:Colors.globalColor9 }}>
    <div className="" style={{overflowY:'scroll', backgroundColor:Colors.globalColor9, padding:'20px' }}>
      {/* <Grid
                container
                spacing={2}
                direction="row"
                justify="flex-start"
                alignItems="flex-start"
            > */}
      {/* <SearchBar
        value={value}
        handleSideBarSubmit={handleSideBarSubmit}
        handleSideBarChange={handleSideBarChange}
        templates={templates}
        inspections={inspections}
        sites={sites}
        packageDetails={packageDetails}
        btnLoader={btnLoader}
        setBtnLoader={setBtnLoader}
      /> */}
      <Dialog
          onClose={()=>{setModal("dashboard",false)}}
          aria-labelledby="max-width-dialog-title"
          open={openModal}
          fullWidth={true}
          maxWidth={"sm"}
          scroll={"paper"}
          className="executiveDashModal"
        >
          <React.Fragment>
            <Grid
              item
              xs={12}
              style={{ alignSelf: "flex-end", cursor: "pointer" }}
              onClick={()=>{setModal("dashboard",false)}}
            >
              <CloseIcon fontSize="medium" style={{ color: "#043077" }} />
            </Grid>
            <SearchBar
            value={value}
            handleSideBarSubmit={handleSideBarSubmit}
            handleSideBarChange={handleSideBarChange}
            templates={templates}
            companies={companies}
            inspections={inspections}
            sites={sites}
            packageDetails={packageDetails}
            btnLoader={btnLoader}
            setBtnLoader={setBtnLoader}
          />
          </React.Fragment>
        </Dialog>
      <TabBar active={"dashboard"} setModal={setModal}/>
      
      <FirstCard
        value={value}
        handleSideBarSubmit={handleSideBarSubmit}
        handleSideBarChange={handleSideBarChange}
        templates={templates}
        inspections={inspections}
        sites={sites}
        packageDetails={packageDetails}
        handleAuditClick={handleAuditClick}
        handleAuditorClick={handleAuditorClick}
        handleNameClick={handleNameClick}
        dataGlobal={dataGlobal}
        handleLocationClick={handleLocationClick}
        barChartData={barChartData}
        dateChart={dateChart}
        filterByDateChart={filterByDateChart}
        setTableFilterOption={setTableFilterOption}
        tableData={tableData}
        toggletable={toggletable}
        tableFilterDate={tableFilterDate}
        tableFilterOption={tableFilterOption}
        handlePdfDownload={handlePdfDownload}
        setDownloadIndex={setDownloadIndex}
        downloadIndex={downloadIndex}
        btnLoader={btnLoader}
        setBtnLoader={setBtnLoader}
      />
      <MyDataGrid
        value={value}
        handleSideBarSubmit={handleSideBarSubmit}
        handleSideBarChange={handleSideBarChange}
        templates={templates}
        inspections={inspections}
        sites={sites}
        packageDetails={packageDetails}
        handleAuditClick={handleAuditClick}
        handleAuditorClick={handleAuditorClick}
        handleNameClick={handleNameClick}
        dataGlobal={dataGlobal}
        handleLocationClick={handleLocationClick}
        barChartData={barChartData}
        dateChart={dateChart}
        filterByDateChart={filterByDateChart}
        setTableFilterOption={setTableFilterOption}
        tableData={tableData}
        toggletable={toggletable}
        tableFilterDate={tableFilterDate}
        tableFilterOption={tableFilterOption}
        handlePdfDownload={handlePdfDownload}
        setDownloadIndex={setDownloadIndex}
        downloadIndex={downloadIndex}
      />
      {/* <StatusandFilters /> */}
      {/* </Grid> */}
    </div>
    

    </div>
    
  );
};
